import { React, useState, useContext, useRef, useEffect } from 'react'
import { MyContextProvider } from "../../../../App";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
    addMonthsToDateString,
    getFormattedDate, isEndDateGreater, changeDateFormat, getMonthRange
} from '../../../../Custom/Custom'
import { GlobalLoading, showLoading } from 'react-global-loading';
import axios from 'axios';
import { API_URL, getAuthHeaders, getUserClaimsForUi } from '../../../../Constant';
import messages from '../../../../assets/Messages.json';
import { ToastContainer, toast } from 'react-toastify';
import { WholesalePriceComparisionReportSheet } from '../../../../Custom/PriceWagesIndiceSystemReport/ExportExcel';
import priceTitle from '../../../../price.json';
import ReactEcharts from "echarts-for-react";

const WholesalePriceComparisionReport = () => {
    const chartRef = useRef(null);
    const token = useContext(MyContextProvider).token;
    const decode_token = getUserClaimsForUi();
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState('');
    const [reportType, setReportType] = useState('');
    const [topFiveItemsObject, settopFiveItemsObject] = useState({});

    const storedLanguage = localStorage.getItem('language');
    const today = new Date();
    const config = getAuthHeaders();

    const handleDropdownChange = (e) => {

        setStartDate(e);
        const currentDate = getFormattedDate(e)
        if (reportType === 'monthly') {
            let stringData = addMonthsToDateString(currentDate, 0);
            let date = stringData[0] + stringData.slice(1).toLocaleLowerCase()
            setEndDate(date);
        } else { //Quarterly
            let stringData = addMonthsToDateString(currentDate, 2);
            let date = stringData[0] + stringData.slice(1).toLocaleLowerCase()
            setEndDate(date);
        }

    };


    const handleReportTypeChange = (e) => {
        setReportType(e.target.value)
        setStartDate(null);
        setEndDate('');

    }


    const handleGenerateExcel = async () => {



        if (reportType === '') {
            toast.error('Please select Report Type', messages.COLOR_RED);
            return
        }
        if (!startDate || !endDate) {
            toast.error('Please select the date range', messages.COLOR_RED);
            return;
        }


        let sDate = getFormattedDate(startDate);
        let eDate = sDate;

        if (reportType === 'quarterly') {
            if (!endDate) {
                toast.error('Please select an end date', messages.COLOR_RED);
                return;
            }
            eDate = endDate[0] + endDate.slice(1).toLocaleUpperCase();
        }

        if (reportType === 'quarterly' && !isEndDateGreater(startDate, endDate)) {
            toast.error(messages.DATE_BETWEEN_MESSAGE, messages.COLOR_RED);
            return;
        }

        try {
            showLoading(true);

            let post_data = {
                fromDate: sDate,
                toDate: eDate,
                duration: reportType
            }


            const response = await axios.post(`${API_URL}api/price/WholeSalePriceComparisonReport`, post_data, config);
            const reportData = response.data.data;

            if (response.data.status) {
                let allData = reportData;

                const toNum = (v) => {
                    const n = parseFloat(v);
                    return Number.isFinite(n) ? Number(n.toFixed(2)) : 0;
                };
                const item = allData.PRICELIST?.[0] || {};
                const chartList = allData.CHARTPRICELIST || [];

                // Chart needs WPI index: All Group, Primary Articles, Manufacturer, Fuel Power
                // CHARTPRICELIST: m13/m1/m2/m3. PRICELIST fallback: current m15/m4/m5/m6, prev month m16/m7/m8/m9, prev year m17/m10/m11/m12
                const seriesFromChartRow = (row, fallback) => {
                    if (row && (row.m13 != null || row.m1 != null || row.m2 != null || row.m3 != null)) {
                        return [toNum(row.m13), toNum(row.m1), toNum(row.m2), toNum(row.m3)];
                    }
                    return fallback;
                };

                const currentData = seriesFromChartRow(
                    chartList[0],
                    [toNum(item.m15), toNum(item.m4), toNum(item.m5), toNum(item.m6)]
                );
                const previousMonthData = seriesFromChartRow(
                    chartList[1],
                    [toNum(item.m16), toNum(item.m7), toNum(item.m8), toNum(item.m9)]
                );
                const previousYearData = seriesFromChartRow(
                    chartList[2],
                    [toNum(item.m17), toNum(item.m10), toNum(item.m11), toNum(item.m12)]
                );

                const currentName = chartList[0]?.year || String(sDate || 'Current');
                const previousMonthName = chartList[1]?.year || 'Previous Month';
                const previousYearName = chartList[2]?.year || 'Previous Year';

                const topFiveItemsObjectdata = {
                    tooltip: { trigger: 'axis' },
                    legend: { data: [currentName, previousMonthName, previousYearName] },
                    color: ['#FF5733', '#1F51FF', '#4F7942'],
                    xAxis: {
                        type: 'category',
                        data: ['All Group', 'Primary Articles', 'Manufacturer', 'Fuel Power'],
                        axisLabel: {
                            interval: 0,
                            align: 'center'
                        }
                    },
                    yAxis: {
                        type: 'value',
                        min: 0,
                        axisLabel: {
                            formatter: '{value}'
                        }
                    },
                    series: [
                        {
                            name: currentName,
                            type: 'bar',
                            data: currentData,
                            label: { show: true, position: 'top', formatter: '{c}', color: '#000' },
                        },
                        {
                            name: previousMonthName,
                            type: 'bar',
                            data: previousMonthData,
                            label: { show: true, position: 'top', formatter: '{c}', color: '#000' },
                        },
                        {
                            name: previousYearName,
                            type: 'bar',
                            data: previousYearData,
                            label: { show: true, position: 'top', formatter: '{c}', color: '#000' },
                        }
                    ]
                };

                settopFiveItemsObject(topFiveItemsObjectdata)
                return {
                    allData: allData,
                    reportType: reportType,
                    sDate: sDate,
                    eDate: eDate,
                }

            } else {
                toast.error('Data is not found', messages.COLOR_RED);
                return;
            }


        } catch (error) {
            console.error(error);

        } finally {
            showLoading(false);
        }
    }


    const handleButtonClick = async () => {
        let data = await handleGenerateExcel();
        setTimeout(() => {
            const image = handleDownload();
            if (image) {
                let parmsdata = data
                parmsdata.chartImage = image
                downloadReport(parmsdata)
            } else {
                console.error('Image URL is null');
            }
        }, 1000);
    };




    const downloadReport = ({ allData, report, sDate, eDate, chartImage }) => {
        const toNum = (v) => {
            const n = parseFloat(v);
            return Number.isFinite(n) ? Number(n.toFixed(2)) : 0;
        };
        const calcPct = (current, previous) => {
            const c = parseFloat(current);
            const p = parseFloat(previous);
            if (!Number.isFinite(c) || !Number.isFinite(p) || p === 0) return '0.0';
            return ((c - p) * 100 / p).toFixed(1);
        };

        const item = allData?.PRICELIST?.[0] || {};
        const chartList = allData?.CHARTPRICELIST || [];
        const currentName = chartList[0]?.year || String(sDate || 'Current');
        const previousMonthName = chartList[1]?.year || (reportType === 'monthly' ? 'Previous Month' : 'Previous Quarter');
        const previousYearName = chartList[2]?.year || 'Previous Year';

        const groups = [
            { name: 'All Groups', current: item.m15 ?? chartList[0]?.m13, previous: item.m16 ?? chartList[1]?.m13, previousYear: item.m17 ?? chartList[2]?.m13, pctPrev: item.m13 },
            { name: 'Primary Articles', current: item.m4 ?? chartList[0]?.m1, previous: item.m7 ?? chartList[1]?.m1, previousYear: item.m10 ?? chartList[2]?.m1, pctPrev: item.m1 },
            { name: 'Manufacturer', current: item.m5 ?? chartList[0]?.m2, previous: item.m8 ?? chartList[1]?.m2, previousYear: item.m11 ?? chartList[2]?.m2, pctPrev: item.m2 },
            { name: 'Fuel Power', current: item.m6 ?? chartList[0]?.m3, previous: item.m9 ?? chartList[1]?.m3, previousYear: item.m12 ?? chartList[2]?.m3, pctPrev: item.m3 },
        ];

        const excelRowData = groups.map((g) => ([
            g.name,
            toNum(g.current),
            toNum(g.previous),
            toNum(g.previousYear),
            g.pctPrev != null && g.pctPrev !== '' ? String(g.pctPrev) : calcPct(g.current, g.previous),
            calcPct(g.current, g.previousYear),
        ]));

        const secondRowText = reportType === 'monthly'
            ? `उत्तर प्रदेश के थोक भाव सूचकांक (आधार वर्ष 2011 -12 =100) ${sDate}`
            : `उत्तर प्रदेश के थोक भाव सूचकांक (आधार वर्ष 2011 -12 =100) ${sDate} - ${eDate}`;

        const tableThirdRowText = reportType === 'monthly'
            ? `वर्तमान माह, गत माह एवं गत वर्ष के सम्वादी माह का तुलनात्मक विवरण`
            : `वर्तमान त्रैमास, गत त्रैमास एवं गत वर्ष के सम्वादी त्रैमास का तुलनात्मक विवरण`;

        const chartThirdRowText = reportType === 'monthly'
            ? `वर्तमान माह, गत माह एवं गत वर्ष के सम्वादी माह का तुलनात्मक चार्ट`
            : `वर्तमान त्रैमास, गत त्रैमास एवं गत वर्ष के सम्वादी त्रैमास का तुलनात्मक चार्ट`;

        const pctPrevLabel = reportType === 'monthly' ? '% Variation (vs Prev Month)' : '% Variation (vs Prev Quarter)';

        const excelObjectSteetData1 = {
            sheetType: 'sheet1',
            fileType: 'xlsx',
            sheetName: 'WPI_Index_Table',
            firstRowMergeCells: 'A1:F1',
            firstRowExportDate: changeDateFormat(new Date()),
            secondRowMergeCells: 'A2:F2',
            secondRowText,
            thirdRowMergeCells: 'A3:F3',
            thirdRowText: tableThirdRowText,
            headerEnglishColumns: [
                'Groups',
                currentName,
                previousMonthName,
                previousYearName,
                pctPrevLabel,
                '% Variation (vs Prev Year)',
            ],
            excelRowData,
        };

        const excelObjectSteetData2 = {
            base64String: chartImage,
            sheetType: 'sheet2',
            fileType: 'xlsx',
            sheetName: 'WPI_Index_chart',
            firstRowMergeCells: 'A1:F1',
            firstRowExportDate: changeDateFormat(new Date()),
            secondRowMergeCells: 'A2:F2',
            secondRowText,
            thirdRowMergeCells: 'A3:F3',
            thirdRowText: chartThirdRowText,
            headerEnglishColumns: ['', '', '', ''],
        };

        let finalObject = {
            excelObjectData: [
                excelObjectSteetData1,
                excelObjectSteetData2
            ],
            fileName: 'WholesalePriceComparision.xls',
        }
        WholesalePriceComparisionReportSheet(finalObject);
    }


    const handleDownload = () => {
        if (chartRef.current) {

            const chartInstance = chartRef.current.getEchartsInstance();
            const imageUrl = chartInstance.getDataURL({
                type: 'png',
                pixelRatio: 4,
                backgroundColor: '#fff',
            });
            return imageUrl;
        }
        return null;
    };



    return (
        <>
            <ToastContainer />
            <GlobalLoading />
            <div className="container-fluid py-3">
                <div className="card mx-3 mb-3">
                    <div className="card-body pb-1">
                        <div className="row align-items-center">
                            <h4 className="page_heading">
                                <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? priceTitle.hi.WHOLESALE_PRICE_COMPARISION_REPORT : priceTitle.en.WHOLESALE_PRICE_COMPARISION_REPORT }} />
                            </h4>
                            <div className="row align-items-center">
                                <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                                    <label> Select Report Type</label>
                                    <select
                                        name="report_type"
                                        className="form-select"
                                        onChange={handleReportTypeChange}
                                        value={reportType}
                                    >
                                        <option value="" disabled>[---Select--]</option>
                                        <option value="monthly">Monthly</option>
                                        <option value="quarterly">Quarterly</option>
                                    </select>
                                </div>

                                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                                    <label className="fw-bold h6">From Date</label>
                                    <DatePicker
                                        className="form-control calendar_icon"
                                        selected={startDate}
                                        onChange={handleDropdownChange}
                                        dateFormat="MMM yyyy"
                                        showMonthYearPicker
                                        placeholderText="Select month"
                                        name="startDate"
                                        maxDate={today}
                                    />
                                </div>
                                {reportType === 'quarterly' && (
                                    <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                                        <label className="fw-bold h6">To Date</label>
                                        <input
                                            className="form-control"
                                            type="text"
                                            name="endDate"
                                            value={endDate}
                                            readOnly
                                        />
                                    </div>
                                )}

                                <div className="col-xl-2 col-lg-4 mb-3">
                                    <label className="w-100 d-none d-sm-block">&nbsp;</label>
                                    <button onClick={handleButtonClick} className="btn btn_orange">Get Report</button>
                                </div>
                                <div style={{ position: 'absolute', left: '-9999px' }}>
                                    {<ReactEcharts ref={chartRef} option={topFiveItemsObject} notMerge={true} style={{ height: '400px', width: '100%' }} />}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

}
export default WholesalePriceComparisionReport